import { render } from "./WildBookObserveSpecCoordinates.vue?vue&type=template&id=322b596c&scoped=true&ts=true"
import script from "./WildBookObserveSpecCoordinates.vue?vue&type=script&lang=ts"
export * from "./WildBookObserveSpecCoordinates.vue?vue&type=script&lang=ts"

import "./WildBookObserveSpecCoordinates.vue?vue&type=style&index=0&id=322b596c&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-322b596c"]])

export default __exports__